export { PasswordRecoveryComponent } from './password-recovery.component';
export { PasswordRecoveryModule } from './password-recovery.module';
